export default "__VITE_ASSET__Dz71$FMs__"